import React from 'react';
import { motion } from 'framer-motion';
import { usePortal } from '../contexts/PortalContext';
import { useAuth } from '../contexts/AuthContext';
import CompanyGrid from '../components/CompanyGrid';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBuilding, FiRefreshCw } = FiIcons;

const Companies = () => {
  const { companies, loading, error, refreshCompanies } = usePortal();
  const { user } = useAuth();

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 flex items-center space-x-3">
              <SafeIcon icon={FiBuilding} className="h-8 w-8 text-primary-600" />
              <span>Companies</span>
            </h1>
            <p className="mt-2 text-gray-600">
              Welcome back, {user?.name}. Select a company to access its dashboards and reports.
            </p>
          </div>
          <button
            onClick={refreshCompanies}
            disabled={loading}
            className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            <SafeIcon icon={FiRefreshCw} className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
            <span>Refresh</span>
          </button>
        </div>
      </motion.div>

      {error && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4"
        >
          <h3 className="text-sm font-medium text-red-800">Error loading companies</h3>
          <p className="text-sm text-red-700 mt-1">{error}</p>
          <button
            onClick={refreshCompanies}
            className="mt-2 text-sm text-red-600 hover:text-red-500 font-medium"
          >
            Try again
          </button>
        </motion.div>
      )}

      <CompanyGrid companies={companies} loading={loading} />

      {!loading && companies.length > 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-8 text-center text-sm text-gray-500"
        >
          Showing {companies.length} compan{companies.length === 1 ? 'y' : 'ies'} you have access to
        </motion.div>
      )}
    </div>
  );
};

export default Companies;